import React from 'react';

const FALLBACK_COVER = '/images/cover-placeholder.jpg';

/**
 * The persistent frosted dock: playback never stops because you went
 * somewhere. Cover/title expands back into the full player view.
 */
export default function MiniDock({engine, isLiked, onLike, onExpand}) {
    const {
        playingSong, title, artist, coverUrl, isPlaying, isMuted, volume,
        togglePlay, previous, next, mute, setVolume, progress,
    } = engine;

    if (!playingSong.id) {
        return null;
    }

    return (
        <div className="fixed inset-x-3 bottom-3 z-30 sm:inset-x-6">
            <div className="mx-auto max-w-[860px] overflow-hidden rounded-2xl bg-white/[0.08] shadow-[inset_0_1px_0_rgba(255,255,255,0.16),0_24px_60px_rgba(0,0,0,0.55)] backdrop-blur-2xl">
                <div
                    className="h-[5px] cursor-pointer bg-white/10"
                    onClick={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        engine.seekToFraction((e.clientX - rect.left) / rect.width);
                    }}
                >
                    <div className="pointer-events-none h-full bg-apple-red transition-[width] duration-300" style={{width: (progress * 100) + '%'}}/>
                </div>
                <div className="flex items-center gap-3 px-3 py-2.5 sm:gap-4 sm:px-4">
                    <button type="button" onClick={onExpand} title="Open player"
                            className="flex min-w-0 flex-1 items-center gap-3 text-left">
                        <img src={coverUrl || playingSong.cover || FALLBACK_COVER} alt=""
                             className="h-10 w-10 flex-none rounded-lg object-cover shadow-[0_8px_20px_rgba(0,0,0,0.4)]"/>
                        <span className="min-w-0">
                            <span className="block truncate text-[13px] font-semibold">
                                {title || playingSong.songTitle || ''}
                            </span>
                            <span className="block truncate text-[11px] text-white/50">{artist || ''}</span>
                        </span>
                    </button>

                    <div className="flex flex-none items-center gap-1 sm:gap-2">
                        <button type="button" onClick={previous} title="Previous"
                                className="flex h-8 w-8 items-center justify-center rounded-full text-white/70 transition hover:text-white">
                            <i className="fa-solid fa-backward-step text-[13px]"/>
                        </button>
                        <button type="button" onClick={togglePlay} title={isPlaying ? 'Pause' : 'Play'}
                                className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#111] transition hover:scale-105">
                            <i className={'fa-solid ' + (isPlaying ? 'fa-pause' : 'fa-play pl-0.5') + ' text-[12px]'}/>
                        </button>
                        <button type="button" onClick={next} title="Next"
                                className="flex h-8 w-8 items-center justify-center rounded-full text-white/70 transition hover:text-white">
                            <i className="fa-solid fa-forward-step text-[13px]"/>
                        </button>
                    </div>

                    <button
                        type="button"
                        onClick={onLike}
                        title={isLiked ? 'In your Discovered by AbTunes.com playlist' : 'Add to your Discovered by AbTunes.com playlist'}
                        className={'flex h-8 w-8 flex-none items-center justify-center rounded-full transition '
                            + (isLiked ? 'text-apple-red' : 'text-white/60 hover:text-white')}
                    >
                        <i className={'fa-solid text-[14px] ' + (isLiked ? 'fa-check' : 'fa-plus')}/>
                    </button>

                    <div className="hidden w-28 flex-none items-center gap-2 md:flex">
                        <button type="button" onClick={mute} className="text-white/60 transition hover:text-white">
                            <i className={'fa-solid text-[12px] ' + (isMuted ? 'fa-volume-xmark' : 'fa-volume-high')}/>
                        </button>
                        <input type="range" min="0" max="1" step="0.01" value={isMuted ? 0 : volume}
                               onChange={(e) => setVolume(parseFloat(e.target.value))}
                               className="h-1 flex-1 cursor-pointer appearance-none rounded-full bg-white/20 accent-white"/>
                    </div>
                </div>
            </div>
        </div>
    );
}
